import { AddressDeliverabilityResult } from 'generated/types'

export const addressVerificationError = (result: AddressDeliverabilityResult) =>
  result?.__typename === 'AddressDeliverabilityVerificationError'

export const addressVerified = (result: AddressDeliverabilityResult) =>
  result?.__typename === 'AddressDeliverabilityVerified'

export const correctedAddress = (result: AddressDeliverabilityResult) =>
  result?.__typename === 'AddressDeliverabilityCorrectedAddress'

export const addressDeliverabilityUnavailable = (result: AddressDeliverabilityResult) =>
  result?.__typename === 'AddressDeliverabilityUnavailableError'
